export class CategoriesModel {
    id: number;
    name: string;
    file: File;
    parentId: string;
    constructor() {
        this.parentId = '';
    }
}
